import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';

import { FareModule } from '..';
import { CancellationQuoteResumeComponent } from './cancellation-quote-resume.component';

@NgModule({
  declarations: [CancellationQuoteResumeComponent],
  imports: [CommonModule, FareModule, SharedModule],
  exports: [CancellationQuoteResumeComponent],
})
export class CancellationQuoteResumeModule {}
